import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

import { useNavigate } from "react-router-dom";

export default function AdminDashboard() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null);

  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;

  const navigate = useNavigate();

  const [currentUser, setCurrentUser] = useState(null);

  // ✅ Get Logged-in User + Role from DB
  useEffect(() => {
  const getUser = async () => {
    try {
      // Auth user
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();

      if (error || !user) {
        navigate("/");
        return;
      }

      console.log("AUTH USER:", user);

      // Match using email
      const { data: dbUser, error: dbError } = await supabase
        .from("users")
        .select("*")
        .eq("email", user.email)
        .maybeSingle();

      if (dbError) {
        console.error(dbError);
        return;
      }

      if (!dbUser) {
        alert("User not found in users table");
       navigate("/");
        return;
      }

      console.log("DB USER:", dbUser);

      setCurrentUser(dbUser);

      // Restrict
      if (dbUser.role !== "super_admin") {
        navigate("/gis-data");
      }
    } catch (err) {
      console.error(err);
     navigate("/");
    }
  };

  getUser();
}, [navigate]);
  // ✅ Only allow super_admin
  useEffect(() => {
    if (!currentUser) return;

    console.log("Role:", currentUser.role);

    if (currentUser.role !== "super_admin") {
      navigate("/gis-data");
    }
  }, [currentUser, navigate]);

  // ✅ Fetch Users
  const fetchUsers = async () => {
    setLoading(true);

    const { data, error } = await supabase
      .from("users")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.error(error.message);
    } else {
      setUsers(data || []);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (currentUser?.role === "super_admin") {
      fetchUsers();
    }
  }, [currentUser]);

  // ✅ FILTER + SEARCH
  useEffect(() => {
    let temp = [...users];

    if (filter !== "all") {
      temp = temp.filter((u) => u.status === filter);
    }

    if (search) {
      temp = temp.filter(
        (u) =>
          u.name?.toLowerCase().includes(search.toLowerCase()) ||
          u.email?.toLowerCase().includes(search.toLowerCase())
      );
    }

    setFilteredUsers(temp);
    setCurrentPage(1);
  }, [filter, search, users]);

  // ✅ PAGINATION
  const indexOfLast = currentPage * usersPerPage;
  const indexOfFirst = indexOfLast - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  // ✅ Approve User
  const approveUser = async (id) => {
    setActionLoading(id);

    const { error } = await supabase
      .from("users")
      .update({ status: "approved" })
      .eq("id", id);

    if (error) {
      alert(error.message);
    } else {
      fetchUsers();
    }

    setActionLoading(null);
  };

  // ✅ Reject User
  const rejectUser = async (id) => {
    setActionLoading(id);

    const { error } = await supabase
      .from("users")
      .update({ status: "rejected" })
      .eq("id", id);

    if (error) {
      alert(error.message);
    } else {
      fetchUsers();
    }

    setActionLoading(null);
  };

  // ✅ Delete User
  const deleteUser = async (id) => {
    if (id === currentUser?.id) {
      return alert("You cannot delete yourself");
    }

    if (!window.confirm("Delete this user?")) return;

    setActionLoading(id);

    const { error } = await supabase
      .from("users")
      .delete()
      .eq("id", id);

    if (error) {
      alert(error.message);
    } else {
      fetchUsers();
    }

    setActionLoading(null);
  };

  // ✅ Change Role
  const changeRole = async (id, role) => {
    const newRole = role === "admin" ? "user" : "admin";

    const { error } = await supabase
      .from("users")
      .update({ role: newRole })
      .eq("id", id);

    if (error) {
      alert(error.message);
    } else {
      fetchUsers();
    }
  };

  // ✅ Loading Screen
  if (!currentUser) {
  return (
    <div style={{ padding: "20px" }}>
      <h3>Loading...</h3>
    </div>
  );
}

  return (
   
      <div style={{ padding: "20px" }}>
        <h2>👑 Super Admin Dashboard</h2>

        {/* SEARCH + FILTER */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <input
            type="text"
            placeholder="Search name or email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={inputStyle}
          />

          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={inputStyle}
          >
            <option value="all">All</option>
            <option value="approved">Approved</option>
            <option value="pending">Pending</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>

        {/* TABLE */}
        {loading ? (
          <p>Loading users...</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={table}>
              <thead>
                <tr style={{ background: "#007bff", color: "#fff" }}>
                  <th style={th}>Name</th>
                  <th style={th}>Email</th>
                  <th style={th}>Role</th>
                  <th style={th}>Status</th>
                  <th style={th}>Online</th>
                  <th style={th}>Last Login</th>
                  <th style={th}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {currentUsers.length === 0 ? (
                  <tr>
                    <td colSpan="7" style={{ padding: "20px" }}>
                      No users found
                    </td>
                  </tr>
                ) : (
                  currentUsers.map((u) => (
                    <tr key={u.id}>
                      <td style={td}>{u.name || "-"}</td>

                      <td style={td}>{u.email}</td>

                      {/* ROLE */}
                      <td style={td}>
                        <span style={getRoleStyle(u.role)}>
                          {u.role}
                        </span>

                        {u.role !== "super_admin" && (
                          <button
                            onClick={() =>
                              changeRole(u.id, u.role)
                            }
                            style={btnSmall}
                          >
                            Switch
                          </button>
                        )}
                      </td>

                      {/* STATUS */}
                      <td style={td}>
                        <span style={getStatusStyle(u.status)}>
                          {u.status}
                        </span>
                      </td>

                      {/* ONLINE */}
                      <td style={td}>
                        {u.is_online
                          ? "🟢 Online"
                          : "⚪ Offline"}
                      </td>

                      {/* LAST LOGIN */}
                      <td style={td}>
                        {u.last_login
                          ? new Date(
                              u.last_login
                            ).toLocaleString()
                          : "-"}
                      </td>

                      {/* ACTIONS */}
                      <td style={td}>
                        {u.role !== "super_admin" ? (
                          <>
                            {u.status !== "approved" && (
                              <button
                                disabled={
                                  actionLoading === u.id
                                }
                                onClick={() =>
                                  approveUser(u.id)
                                }
                                style={btnGreen}
                              >
                                Approve
                              </button>
                            )}

                            <button
                              disabled={
                                actionLoading === u.id
                              }
                              onClick={() =>
                                rejectUser(u.id)
                              }
                              style={btnRed}
                            >
                              Reject
                            </button>

                            <button
                              disabled={
                                actionLoading === u.id
                              }
                              onClick={() =>
                                deleteUser(u.id)
                              }
                              style={btnBlack}
                            >
                              Delete
                            </button>
                          </>
                        ) : (
                          <span style={{ color: "gray" }}>
                            Protected
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {/* PAGINATION */}
            {totalPages > 1 && (
              <div style={{ marginTop: "15px" }}>
                {Array.from(
                  { length: totalPages },
                  (_, i) => (
                    <button
                      key={i}
                      onClick={() =>
                        setCurrentPage(i + 1)
                      }
                      style={{
                        marginRight: "5px",
                        padding: "5px 10px",
                        background:
                          currentPage === i + 1
                            ? "#007bff"
                            : "#eee",
                        color:
                          currentPage === i + 1
                            ? "#fff"
                            : "#000",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {i + 1}
                    </button>
                  )
                )}
              </div>
            )}
          </div>
        )}
      </div>
   
  );
}

/* 🎨 STYLES */

const table = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "20px",
};

const th = {
  padding: "10px",
  textAlign: "left",
};

const td = {
  padding: "10px",
  borderBottom: "1px solid #ddd",
};

const inputStyle = {
  padding: "8px",
  borderRadius: "5px",
  border: "1px solid #ccc",
};

const btnGreen = {
  background: "green",
  color: "#fff",
  padding: "5px 10px",
  border: "none",
  marginRight: "5px",
  cursor: "pointer",
};

const btnRed = {
  background: "red",
  color: "#fff",
  padding: "5px 10px",
  border: "none",
  marginRight: "5px",
  cursor: "pointer",
};

const btnBlack = {
  background: "black",
  color: "#fff",
  padding: "5px 10px",
  border: "none",
  cursor: "pointer",
};

const btnSmall = {
  marginLeft: "5px",
  fontSize: "11px",
  padding: "3px 6px",
  cursor: "pointer",
};

/* 🎯 Dynamic Styles */

const getRoleStyle = (role) => ({
  background:
    role === "super_admin"
      ? "#6f42c1"
      : role === "admin"
      ? "#007bff"
      : "#6c757d",

  color: "#fff",
  padding: "4px 8px",
  borderRadius: "10px",
  marginRight: "5px",
});

const getStatusStyle = (status) => ({
  background:
    status === "approved"
      ? "#28a745"
      : status === "pending"
      ? "#ffc107"
      : "#dc3545",

  color: "#fff",
  padding: "4px 8px",
  borderRadius: "10px",
});